import { GlobalModal } from "constants/globalModal";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface ShowGlobalModalActionInterface {
  readonly type: "SHOW_GLOBAL_MODAL";
  readonly payload: {
    readonly modal: GlobalModal;
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly payload?: any;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface HideGlobalModalActionInterface {
  readonly type: "HIDE_GLOBAL_MODAL";
  readonly payload: {
    readonly modal: GlobalModal;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showGlobalModal = ({ modal, payload }: any): ShowGlobalModalActionInterface => ({
  type: "SHOW_GLOBAL_MODAL",
  payload: { modal, payload },
});

export const hideGlobalModal = (modal: GlobalModal): HideGlobalModalActionInterface => ({
  type: "HIDE_GLOBAL_MODAL",
  payload: { modal },
});

export type GlobalModalActions = ShowGlobalModalActionInterface | HideGlobalModalActionInterface;
